/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsPortfolioResponse extends models.AppSecopsPortfolio {
    getFixupPrototypeFunction() { return AppSecopsPortfolioResponse.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsPortfolioResponse>): AppSecopsPortfolioResponse {
        let obj = Object.assign(new AppSecopsPortfolioResponse(), model);
        AppSecopsPortfolioResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsPortfolioResponse>): AppSecopsPortfolioResponse {
        if (!model) return null;
        return AppSecopsPortfolioResponse.newInstance(<AppSecopsPortfolioResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsPortfolioResponse) {
        if (!obj) return;

        models.AppSecopsPortfolioResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsPortfolioResponse): boolean {
        if (models.AppSecopsPortfolio.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsPortfolioResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
